import React, { useEffect, useState } from "react";
import { Button, Divider, Grid, Typography } from "@mui/material";
import { showSnackbar } from "../../../../slice/snackbarSlice";
import { useDispatch, useSelector } from "react-redux";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import WorkflowCard from "./WorkflowCard";
import CreateUpdateWorkflowDialog from "./CreateUpdateWorkflowDialog";
import { getInstructionType } from "../../../../thunks/instruction";
import { getWorkflowList } from "../../../../thunks/workflow";
import { useNavigate, useParams } from "react-router-dom";
import { NOTIFICATION_MESSAGE } from "../../../../utils/constant";
import Loader from "../../../../components/Loader";
const List = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const lookups = useSelector((state) => state?.lookupData);
  const WorkflowStatus = lookups?.WorkFlowStatus;

  let WorkflowStatusData = WorkflowStatus?.filter((d) => {
    return d.value !== "active";
  });
  const instructionTypeData = useSelector(
    (state) => state?.instruction?.instructionTypeData
  );
  const [expandSection, setExpandSection] = useState({});
  const [workflowData, setWorkflowData] = useState([]);
  const [isLoader, setLoader] = useState(false);
  const [isOpenCreateWorkflowDialog, setOpenCreateWorkflowDialog] = useState({
    open: false,
    instructionId: null,
  });

  //  Method to get the instruction type data from the API
  const getInstructionTypeData = async () => {
    try {
      await dispatch(getInstructionType()).unwrap();
    } catch (error) {
      dispatch(
        showSnackbar({
          show: true,
          message: error?.message || NOTIFICATION_MESSAGE.SOMETHING_WENT_WRONG,
          severity: "error",
        })
      );
    }
  };

  // Method to toggle the arrow icon and expand the content
  const handleToggleDrawer = (status, type) => {
    setExpandSection((prev) => ({
      ...prev,
      [type]: {
        ...(prev[type] || {}),
        [status]: !prev[type]?.[status],
      },
    }));
  };

  // Method to get workflow data from the API and set it in the state for rendering the list
  const getWorkflowData = async () => {
    try {
      setLoader(true);
      const response = await dispatch(getWorkflowList()).unwrap();
      setWorkflowData(response);
    } catch (error) {
      setWorkflowData([]);
      dispatch(
        showSnackbar({
          show: true,
          message: error?.message || NOTIFICATION_MESSAGE.SOMETHING_WENT_WRONG,
          severity: "error",
        })
      );
    } finally {
      setLoader(false);
    }
  };
  const handleOpenCreateWorkflowDialog = (type, typeId) => {
    setOpenCreateWorkflowDialog({
      open: true,
      instructionId: typeId,
      instructionType: type,
    });
  };

  const handleWorkflowOpen = (workflow) => {
    if (workflow?.WorkFlowStatus?.value === "Mapping") {
      navigate(`/app/manage/configure-task/workflowMapping/${workflow?.id}`);
    } else {
      navigate(`/app/manage/configure-task/${workflow?.id}`);
    }
  };

  const handlecloseCreateUpdateDialogue = () => {
    setOpenCreateWorkflowDialog({
      open: false,
      instructionId: null,
    });
  };

  useEffect(() => {
    getInstructionTypeData();
    getWorkflowData();
  }, []);

  return (
    <>
      {isOpenCreateWorkflowDialog.open && (
        <CreateUpdateWorkflowDialog
          getWorkflowList={getWorkflowData}
          open={isOpenCreateWorkflowDialog.open}
          handleClose={handlecloseCreateUpdateDialogue}
          isOpenCreateWorkflowDialog={isOpenCreateWorkflowDialog}
        />
      )}

      {isLoader && <Loader />}

      {/* main container  */}
      <Grid container xs={12} alignItems={"flex-start"}>
        {/* Active text */}
        <Grid marginTop={18} padding={1}>
          <Typography className="serif_display_regular_20 green">
            Active
          </Typography>
        </Grid>

        {instructionTypeData?.map((type) => {
          const activeWorkflows = workflowData.filter((workflow) => {
            return (
              workflow.WorkFlowStatus?.value === "active" &&
              workflow.InstructionType?.value === type?.value
            );
          });
          return (
            <>
              {/* list   container */}
              <Grid container xs={4} key={type?.id}>
                {/* Fixed Header */}
                <Grid
                  item
                  xs={12}
                  p={2}
                  display={"flex"}
                  justifyContent={"space-between"}
                  style={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: "white",
                    zIndex: 10,
                  }}
                >
                  <Typography className="serif_display_regular_22">
                    {type?.name}
                  </Typography>
                  <Button
                    variant="outlined"
                    className="create_workflow_button"
                    onClick={() =>
                      handleOpenCreateWorkflowDialog(type?.name, type?.id)
                    }
                  >
                    Workflow +
                  </Button>
                </Grid>

                {/* Active Workflows Section */}
                {activeWorkflows.length > 0 ? (
                  <Grid
                    item
                    xs={12}
                    // padding={2}
                    style={{
                      overflowY: "auto",
                      // maxHeight: "200px",
                      minHeight: "181px",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    {activeWorkflows.length > 0 && (
                      <WorkflowCard
                        status={"active"}
                        key={activeWorkflows?.[0]?.id}
                        workflowData={activeWorkflows?.[0]}
                        onClick={() => handleWorkflowOpen(activeWorkflows?.[0])}
                        getWorkflowList={getWorkflowData}
                      />
                    )}
                  </Grid>
                ) : (
                  <Grid
                    item
                    xs={12}
                    padding={2}
                    style={{
                      overflowY: "auto",
                      // maxHeight: "350px",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "center",
                      minHeight: "181px",
                    }}
                  >
                    <Typography
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginRight: 2,
                      }}
                      className="serif_display_regular_20 lightGrey"
                    >
                      No active workflow
                    </Typography>
                  </Grid>
                )}

                {/* Divider between Active Card & Drafts */}
                <Grid item xs={12} mt={4} mb={1}>
                  <Divider
                    variant="middle"
                    sx={{ border: "1px solid black" }}
                  />
                </Grid>

                {WorkflowStatusData?.map((status) => {
                  const filteredWorkflows = workflowData.filter((workflow) => {
                    return (
                      workflow.WorkFlowStatus?.value === status?.value &&
                      workflow.InstructionType?.value === type?.value
                    );
                  });

                  return (
                    <>
                      {/* Draft and Previous active section */}
                      <Grid item xs={12} ml={2} key={status?.id}>
                        <Typography
                          style={{ fontSize: "14px" }}
                          className="serif_display_regular_20"
                        >
                          <ArrowDropUpIcon
                            style={{
                              cursor: "pointer",
                              transition: "transform 0.3s",
                              transform: expandSection[type?.value]?.[
                                status?.value
                              ]
                                ? "rotate(180deg)"
                                : "rotate(0deg)",
                              transition: "transform 0.3s",
                              color: expandSection[type?.value]?.[status?.value]
                                ? "#00ce3f"
                                : "inherit",
                            }}
                            onClick={() =>
                              handleToggleDrawer(status?.value, type?.value)
                            }
                          />
                          {status?.label}
                        </Typography>
                      </Grid>

                      {/* Toggle Content */}
                      {expandSection?.[type?.value]?.[status?.value] && (
                        <Grid
                          item
                          xs={12}
                          style={{
                            overflowY: "auto",
                            maxHeight: expandSection?.[type?.value]?.[
                              status?.value
                            ]
                              ? "300px"
                              : "0px",
                            transition: "max-height 0.3s ease-in-out",
                          }}
                        >
                          {filteredWorkflows?.length > 0 ? (
                            filteredWorkflows?.map((workflow) => (
                              <WorkflowCard
                                status={status?.value}
                                key={workflow.id}
                                workflowData={workflow}
                                getWorkflowList={getWorkflowData}
                                onClick={() => handleWorkflowOpen(workflow)}
                              />
                            ))
                          ) : (
                            <Grid
                              item
                              xs={12}
                              padding={2}
                              style={{
                                overflowY: "auto",
                                maxHeight: "350px",
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "120px",
                              }}
                            >
                              <Typography
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  marginRight: 2,
                                }}
                                className="serif_display_regular_20 lightGrey"
                              >
                                No workflow found
                              </Typography>
                            </Grid>
                          )}
                        </Grid>
                      )}

                      {/* Divider between Drafts & Previously Active */}
                      <Grid item xs={12} mb={1} mt={2}>
                        <Divider
                          variant="middle"
                          sx={{ border: "1px solid black" }}
                        />
                      </Grid>
                    </>
                  );
                })}
              </Grid>
              {/* Middle Divider */}
              <Divider
                orientation="vertical"
                flexItem
                variant="middle"
                sx={{ border: "1px solid black", marginInline: 3 }}
              />
            </>
          );
        })}
      </Grid>
    </>
  );
};

export default List;
